import React from "react";

import { SendTo, Supplement } from "../../services/SupplementsServices.dto";
import { FormatedSupplementDoc } from "../../containers/forms/supplements/utils.type";
import { Taker } from "../../containers/forms/supplements/basic-data/basic-data.types";
import { SEND_TO } from "../../constants/supplements";

export type SupplementsContextValue = {
  supplements: Supplement[];
  isLife: boolean;
  supplementId: number;
  supplementChildIds: number[];
  supplementDocs: FormatedSupplementDoc[];
  taker: Taker | {};
  sendTo: SendTo;
  isInsuredInSendaPolicy: boolean;
  setSupplements: (supplements: Supplement[]) => void;
  setIsLife: (isLife: boolean) => void;
  setSupplementId: (id: number) => void;
  setSupplementChildIds: (ids: number[]) => void;
  setSupplementDocs: (docs: FormatedSupplementDoc[]) => void;
  setTaker: (taker: Taker | {}) => void;
  setSendTo: (sendTo: SendTo) => void;
  setIsInsuredInSendaPolicy: (isInsuredInSendaPolicy: boolean) => void;
};

export const SupplementsContext = React.createContext<SupplementsContextValue>({
  supplements: [],
  isLife: false,
  supplementId: NaN,
  supplementChildIds: [],
  supplementDocs: [],
  taker: {},
  sendTo: SEND_TO.BACKOFFICE,
  isInsuredInSendaPolicy: false,
  setSupplements: () => {},
  setIsLife: () => {},
  setSupplementId: () => {},
  setSupplementChildIds: () => {},
  setSupplementDocs: () => {},
  setTaker: () => {},
  setSendTo: () => {},
  setIsInsuredInSendaPolicy: () => {},
});
